<template>
  <BaseModal
    v-if="currentUser"
    :modalTitle="currentUser.fullName"
    contentPadding="none">
    <UiTabNav
      :navItems="navItems"
      class="is-inline border-b border-border-strong px-6"
      @nav-item-click="onNavItemClick" />

    <div class="p-6">
      <UserInfoForm
        v-if="activeTab === 'general'"
        :user="currentUser" />
      <ProfileRolesModalPage
        v-else-if="activeTab === 'roles'"
        :user="currentUser" />
      <component
        v-else-if="activeTab === 'pin-code'"
        :is="EmployeeEditPinCodeView"
        :user="currentUser" />
    </div>
  </BaseModal>
</template>

<script lang="ts">
import { useUserStore } from '@/stores/userStore'
import type { ITabNavOption } from '@team-milva/lab-components'
import { mapState } from 'pinia'
import { defineAsyncComponent, markRaw } from 'vue'

const EmployeeEditPinCodeView = markRaw(
  defineAsyncComponent(() => import('@/components/EmployeeEditPinCodeView.vue'))
)

export default {
  name: 'UserProfileModal',
  data() {
    return {
      activeTab: 'general' as string,
      EmployeeEditPinCodeView,
    }
  },
  computed: {
    ...mapState(useUserStore, ['currentUser']),
    navItems(): ITabNavOption[] {
      return [
        {
          id: 'general',
          title: this.$t('term.details'),
          isActive: this.activeTab === 'general',
        },
        {
          id: 'roles',
          title: this.$t('term.roles'),
          isActive: this.activeTab === 'roles',
        },
        {
          id: 'pin-code',
          title: this.$t('W: Pinkode'),
          isActive: this.activeTab === 'pin-code',
        },
      ]
    },
  },
  methods: {
    onNavItemClick(id: string) {
      this.activeTab = id
    },
  },
}
</script>
